import { CustomSideModel } from '@common/models/predefined-custom-side.model';
import { RootState } from '@redux/store';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';

interface CustomSideState {
    selectedCustomSide?: CustomSideModel;
}

const initialState: CustomSideState = {
    selectedCustomSide: undefined,
};

const customSideSlice = createSlice({
    name: 'customSide',
    initialState,
    reducers: {
        resetSelectedCustomSide: (state) => {
            state.selectedCustomSide = undefined;
        },
        updateSelectedCustomSide: (state, action: PayloadAction<CustomSideModel>) => {
            state.selectedCustomSide = action.payload;
        },
    },
});

export const { resetSelectedCustomSide, updateSelectedCustomSide } = customSideSlice.actions;

export const selectSelectedCustomSide = ({ customSide }: RootState): CustomSideModel | undefined =>
    customSide.selectedCustomSide;

export default customSideSlice.reducer;
